import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { doGetPromise } from '../../core/config/core.httpclient-utils';

@Injectable()
export class GlyphService {
    private cache = {};
    constructor(private http: HttpClient) { }

    isGlyphicon(attrValue: string): boolean {
        return attrValue?.indexOf('glyphicon-') > -1;
    }

    getImageNameFromAttr(attrValue: string): string | false {
        const imgName = attrValue?.split(' ')
            .filter(cls => cls.startsWith('glyph-img-'))
            .map(cls => cls.replace('glyph-img-', ''))
            .shift();

        return imgName ? imgName : false;
    }

    getImageNameForSection(section: string): string {
        const map = {
            'build': 'cicd',
            'cruisecontrol': 'cicd',
            'cruisecontrolbuild': 'cicd',
            'docman': 'document',
            'docmanfile': 'document',
            'docmanfileversion': 'document',
            'docmanfolder': 'document',
            'discussion': 'chat',
            'forum': 'chat',
            'forummessage': 'chat',
            'wall': 'notification',
            'project': 'project',
            'frsrelease': 'release',
            'frspackage': 'release',
            'release': 'release',
            'package': 'release',
            'trackeritem': 'ticket',
            'tracker': 'ticket',
            'trackersprint': 'sprint',
            'trackerquery': 'ticket',
            'scm': 'code',
            'scmcommit': 'commit',
            'snapshot': 'snapshot',
            'wiki': 'wiki',
            'wikipage': 'wiki',
            'user': 'user'
        };

        return map[section] || 'project';
    }

    getImageUrl(imgName: string): string {
        return '/core/img/glyphs/' + imgName + '.svg';
    }

    getImageData(imgName: string): Promise<any> {
        if (! this.cache[imgName]) {       
            this.cache[imgName] = new Promise((resolve, reject) => {
                this.http.get(this.getImageUrl(imgName), { responseType: 'text' }).toPromise()
                    .then(
                        (result: any) => {
                            this.cache[imgName] = result;
                            resolve(this.cache[imgName]);
                        },
                        (response: any) => {
                            console.log("Glyph fetch failed", imgName, response);
                            reject(response);
                        }
                    );
            });
        }
        return this.cache[imgName];
    }
}
